"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createAnimationContainer = exports.getBBox = exports.getRotationAngle = exports.getTransform = exports.getOpacity = void 0;
function getOpacity(targets) {
    var _a;
    if (!Array.isArray(targets) && targets instanceof Element) {
        return Number((_a = targets.getAttribute('opacity')) !== null && _a !== void 0 ? _a : 1);
    }
    return 1;
}
exports.getOpacity = getOpacity;
function getTransform(targets) {
    if (!Array.isArray(targets) && targets instanceof Element) {
        return String(targets.getAttribute('transform'));
    }
    return '';
}
exports.getTransform = getTransform;
function getRotationAngle(targets) {
    if (!Array.isArray(targets) && targets instanceof Element) {
        return Number(getElementRotation(targets));
    }
    return 0;
    function getElementRotation(element, defaultAngle = 0) {
        const transform = element.getAttribute('transform');
        if (!transform || !(transform === null || transform === void 0 ? void 0 : transform.includes('rotate')))
            return defaultAngle;
        return transform.split('rotate(')[1].split(')')[0].split(' ')[0];
    }
}
exports.getRotationAngle = getRotationAngle;
function getBBox(element) {
    if ('getBBox' in element) {
        return element.getBBox();
    }
    return undefined;
}
exports.getBBox = getBBox;
function createAnimationContainer(target) {
    if (!(target === null || target === void 0 ? void 0 : target.parentElement))
        return target;
    const animationContainer = document.createElementNS('http://www.w3.org/2000/svg', 'g');
    animationContainer.setAttribute('class', 'animation-container');
    target.insertAdjacentElement('afterend', animationContainer);
    animationContainer.appendChild(target);
    return animationContainer;
}
exports.createAnimationContainer = createAnimationContainer;
//# sourceMappingURL=gsap-utils.js.map